export function isVisitaWorkDivided(context) {
    return context?.visita?.catalogo_dividido === true || Number(context?.context?.partes_distribuidas?.total || 0) > 0;
}

export function isVisitaOwnershipConflict(error) {
    return error?.response?.status === 409 && ['instance_owner_conflict','attachment_owner_conflict','section_closed','section_not_assigned'].includes(error.response.data?.code);
}

export function canEditVisitaInstance(context, userId, key) {
    if (!isVisitaWorkDivided(context)) return true;
    const section = context?.context?.mi_seccion_catalogo;
    if (!section || section.estado === 'completada' || !Number.isSafeInteger(Number(userId)) || Number(userId) < 1) return false;
    const state = String(key).match(/^g(\d+)_i(?:(\d+)_)?(\d+)$/);
    if (state?.[2] && state[2] !== state[1]) return false;
    const instance = state ? `${state[1]}_${state[3]}` : String(key).match(/^(?:_activo_id_|_gps_)?(\d+_\d+)(?:_sub_.*)?$/)?.[1];
    if (!instance) return true; // Campos sistémicos: conservan su permiso y la parte debe seguir abierta.
    return Number(context?.visita?.instance_owners?.[instance]) === Number(userId);
}

export function canManageVisitaAttachment(context, userId, item) {
    if (!isVisitaWorkDivided(context)) return true;
    return Number(item?.user_id ?? item?.upload_receipt?.user_id) === Number(userId)
        && canEditVisitaInstance(context, userId, item?.instance_ref || '');
}

export function canRemoveVisitaInstances(context, userId, groupIdx, indices) {
    if (!isVisitaWorkDivided(context)) return true;
    if (!indices.length || indices.some(index => !canEditVisitaInstance(context, userId, `${groupIdx}_${index}`))) return false;
    const first = Math.min(...indices);
    return Object.entries(context?.visita?.instance_owners || {}).every(([key, owner]) => {
        const [group, index] = key.split('_');
        return group !== String(groupIdx) || Number(index) <= first || Number(owner) === Number(userId);
    });
}

export function withLocalInstanceOwner(snapshot, userId, instanceKey) {
    return {...snapshot, instance_owners: {...snapshot.instance_owners, [instanceKey]: Number(userId)}};
}
